import { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import useLanguageChange from 'src/common/hooks/useLanguageChange';
import LanguageSelector from '../LanguageSelector';
import style from './Footer.module.scss';

type FooterLanguageSelectorProps = {
  classNameModifier?: string;
};

const FooterLanguageSelector: FC<FooterLanguageSelectorProps> = ({ classNameModifier }) => {
  const { onLanguageChange } = useLanguageChange();
  return (
    <li className={getClassNames(style, 'item', classNameModifier)}>
      <LanguageSelector onChange={onLanguageChange} />
    </li>
  );
};

export default FooterLanguageSelector;
